module.exports = __webpack_public_path__ + "img/RU.b36b3e38.png";